export const ignoreInterceptorHeaders = {
  ignoreLanguage: 'X-Ignore-Language',
  ignoreRetry: 'X-Ignore-Retry',
  ignoreCid: 'X-Ignore-Cid',
  ignoreAuth: 'X-Ignore-Auth',
  ignoreRequestId: 'X-Ignore-RequestId'
};
